import script from "./CopyableLink.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyableLink.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__